import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type BarChartCircle01IconProps = IconProps

const BarChartCircle01Icon = forwardRef<
  SVGSVGElement,
  BarChartCircle01IconProps
>((props: BarChartCircle01IconProps, ref) => (
  <Icon {...props} ref={ref}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 13v4m8-6v6M12 7v10m10-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      fill="none"
    ></path>
  </Icon>
))

BarChartCircle01Icon.displayName = 'BarChartCircle01Icon'
BarChartCircle01Icon.defaultProps = iconDefaultProps

export type { BarChartCircle01IconProps }
export { BarChartCircle01Icon }
